import { ContainerStyled } from './Container.styled';

export const Container = ({ children }) => (
  <ContainerStyled>{children}</ContainerStyled>
);
